import React, { createContext, useContext, useState, useCallback } from "react";

const CheckoutContext = createContext({
    product: null,
    setProduct: () => {},
    isOpen: false,
    openCheckout: () => {},
    closeCheckout: () => {},
});

export function CheckoutProvider({ children }) {
    const [product, setProduct] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const openCheckout = useCallback(() => {
        if (product) setIsOpen(true);
    }, [product]);
    const closeCheckout = useCallback(() => setIsOpen(false), []);

    return (
        <CheckoutContext.Provider
            value={{ product, setProduct, isOpen, openCheckout, closeCheckout }}
        >
            {children}
        </CheckoutContext.Provider>
    );
}

export const useCheckout = () => useContext(CheckoutContext);
